import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/Lectures/Update';

const { displayName } = config;

function LectureUpdate(): React.JSX.Element {
  document.title = `${displayName}: Редактировать лекцию`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
}

export default LectureUpdate;
